import React, { useEffect, useState } from 'react'
import withRouter from '../../Common/withRouter'
import { withTranslation } from 'react-i18next'
import { Input } from 'reactstrap'

const InventoryRow = (props) => {

    const [countedQtyInWarehouse, setCountedQtyInWarehouse] = useState(
      props.row.countedWarehouseQty
    );
    const [countedQtyInPharmacy, setCountedQtyInPharmacy] = useState(
      props.row.countedPharmacyQty
    );
    const [warehouseQty, setWarehouseQty] = useState(
      props.isWatch || props.isEdit
        ? props.row.warehouseQty
        : props.row.qtyInWarehouse
    );
    const [pharmacyQty, setPharmacyQty] = useState(
      props.isWatch || props.isEdit
        ? props.row.pharmacyQty
        : props.row.qtyInPharmacy
    );

    const handleBlur = (e, setValue) => {
        if (e.target.value === '' || e.target.value === '0' || e.target.value <= 1) {
            setValue(1);
        }
    };

    useEffect(() =>{
        if ((countedQtyInWarehouse || countedQtyInPharmacy) > 0) {
          if (props.isValidate) {
            let object = {
              productId: props.row.productId,
              name: props.row.name,
              countedWarehouseQty: countedQtyInWarehouse,
              countedPharmacyQty: countedQtyInPharmacy,
              pharmacyQty: pharmacyQty,
              warehouseQty: warehouseQty,
            };
            props.updateRow(object);
          } else {

			
			
            let object = {
              productId: props.row.productId,
              countedWarehouseQty: countedQtyInWarehouse,
              countedPharmacyQty: countedQtyInPharmacy,
              pharmacyQty: pharmacyQty,
              warehouseQty: warehouseQty,
            };
            props.updateRow(object);
          }
        }
    },[countedQtyInWarehouse, countedQtyInPharmacy])

  return (
    <>
      <td className="text-center">{props.index + 1}</td>
      <td className="text-center">{props.row.name}</td>
      <td className="text-center">
        {props.isWatch || props.isEdit ? (
          <Input
            type="number"
            className={`form-control m-0 text-center ${
              props.isWatch || props.isEdit ? "bg-transparent border-0" : ""
            }`}
            value={warehouseQty}
            onChange={(e) => setWarehouseQty(Number(e.target.value))}
            onBlur={(e) => handleBlur(e, setWarehouseQty)}
            aria-label="Text input with checkbox"
            disabled={props.isWatch || props.isEdit ? true : false}
            min={0}
            defaultValue={0}
          />
        ) : (
          <span>{props.row.qtyInWarehouse}</span>
        )}
      </td>
      <td className="text-center">
        {props.isWatch || props.isEdit ? (
          <Input
            type="number"
            className={`form-control m-0 text-center ${
              props.isWatch || props.isEdit ? "bg-transparent border-0" : ""
            }`}
            value={pharmacyQty}
            onChange={(e) => setPharmacyQty(Number(e.target.value))}
            onBlur={(e) => handleBlur(e, setPharmacyQty)}
            aria-label="Text input with checkbox"
            disabled={props.isWatch || props.isEdit ? true : false}
            min={0}
            defaultValue={0}
          />
        ) : (
          <span>{props.row.qtyInPharmacy}</span>
        )}
      </td>

      <td>
        {
          <Input
            type="number"
            className={`form-control m-0 text-center ${
              props.isWatch ? "bg-transparent border-0" : ""
            }`}
            value={countedQtyInWarehouse}
            onChange={(e) => setCountedQtyInWarehouse(Number(e.target.value))}
            onBlur={(e) => handleBlur(e, setCountedQtyInWarehouse)}
            aria-label="Text input with checkbox"
            disabled={props.isWatch ? true : false}
            min={0}
            defaultValue={0}
          />
        }
      </td>
      <td>
        {
          <Input
            type="number"
            className={`form-control m-0 text-center ${
              props.isWatch ? "bg-transparent border-0" : ""
            }`}
            value={countedQtyInPharmacy}
            onChange={(e) => setCountedQtyInPharmacy(Number(e.target.value))}
            onBlur={(e) => handleBlur(e, setCountedQtyInPharmacy)}
            aria-label="Text input with checkbox"
            disabled={props.isWatch ? true : false}
            min={0}
            defaultValue={0}
          />
        }
      </td>

      {/* Warehouse Difference */}
      {!isNaN(warehouseQty - countedQtyInWarehouse) ? (
        <td className="text-center">
          {warehouseQty - countedQtyInWarehouse < 0
            ? 0
            : warehouseQty - countedQtyInWarehouse}
        </td>
      ) : (
        <td className="text-center">0</td>
      )}

      {/* Pharmacy Difference */}
      {!isNaN(pharmacyQty - countedQtyInPharmacy) ? (
        <td className="text-center">
          {pharmacyQty - countedQtyInPharmacy < 0
            ? 0
            : pharmacyQty - countedQtyInPharmacy}
        </td>
      ) : (
        <td className="text-center">0</td>
      )}

      {/* {!props.isWatch ?
            <td className="text-center" onClick={() => props.deleteRow(props.row) } >
                <i className="fa-solid fa-trash-can delete-action-btn"></i>
            </td>
            :
            <></>
        } */}
    </>
  );
}

export default withRouter(withTranslation()(InventoryRow))
